import {
    LOAD_CATEGORIES_SUCCESS, RESET_CATEGORIES, REORDER_CATEGORIES_SUCCESS
} from '../../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case LOAD_CATEGORIES_SUCCESS:
            return action.payload;
        case REORDER_CATEGORIES_SUCCESS:
            return action.payload;
        case RESET_CATEGORIES:
            return INITIAL_STATE;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/restaurants/posmenu/CategoriesReducer.js